export function formatMoney(value) {
  if (value === null || value === undefined) return '0.00';
  return value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export function formatRate(value) {
  const num = parseFloat(value);
  if (isNaN(num)) return '0.00';
  return num.toFixed(2);
}

export function getProfitClass(value) {
  if (value === null || value === undefined || value === '') return '';
  const num = parseFloat(value);
  if (isNaN(num)) return '';
  if (num > 0) return 'red';
  if (num < 0) return 'green';
  return 'red';
}

export function formatGzTime(s) {
  if (!s) return '';
  const m = String(s).match(/\b(\d{2}:\d{2})\b/);
  return m ? m[1] : s;
}
